import { Component } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import Loading from '../../../../components/Loading';
import { formatNumber } from '../../../../helpers/formatNumber';

class Billing extends Component {
    constructor(props) {
        super(props);

        this.onSubmit = this.onSubmit.bind(this);
        this.handleDefaultChange = this.handleDefaultChange.bind(this);

        this.state = {
            promotion_code: '',
            data: {
                name: '',
                email: '',
                organization: '',
                geo_location: '',
                password: '',
            },
            set_as_default_card: false,
            card: {
                complete: false,
            },
            errors: {},
            step: 1,
            loading: false,
        };
    }

    async componentDidMount() {
        this.stripe = await loadStripe(window._config.stripe_public_key);
        this.elements = this.stripe.elements();

        // Stripe Elements render inside an iframe, so their text color can't be
        // set with our own CSS — it must be passed through Stripe's style API.
        const isDark = document.body.classList.contains('dark-mode');
        this.card = this.elements.create('card', {
            style: {
                base: {
                    color: isDark ? '#ffffff' : '#32325d',
                    '::placeholder': {
                        color: isDark ? '#8b93a7' : '#aab7c4',
                    },
                },
            },
        });
        this.card.mount('#card');

        this.card.on('change', (v) => {
            this.setState({
                card: v,
            });
        });
    }

    async onSubmit(e) {
        try {
            e.preventDefault();
            this.setState({ loading: true });
            let cardToken = await this.stripe.createPaymentMethod({
                type: 'card',
                card: this.card,
                billing_details: {
                    name: this.props.cardholder_name,
                    email: this.props.email,
                },
            });

            const body = {
                payment_method: cardToken?.paymentMethod?.id,
            };

            if (this.props.isEdit) {
                body.set_as_default = this.state.set_as_default_card;
            }

            const response = await this.props.createRequestBody(body);

            if (response?.status === 'error' || this.props.isEdit) {
                this.setState({ loading: false });
            }
        } catch (err) {
            this.setState({ cardError: err.message, loading: false });
        }
    }

    handleDefaultChange(e) {
        this.setState({ set_as_default_card: e.target.checked });
    }

    render() {
        return (
            <form
                onSubmit={this.onSubmit}
                className="registration-container-info-form h-100 single"
            >
                <div className="my-10">
                    <label htmlFor="exampleInputEmail1" className="form-label">
                        Billing Information <span>*</span>
                    </label>
                    <div id="card" />
                    {this.state.cardError && (
                        <div className="error-message">{this.state.cardError}</div>
                    )}
                </div>
                <div className="text-field mb-3">
                    <label htmlFor="exampleInputEmail1" className="form-label">
                        Cardholder Name (if different)
                    </label>
                    <input
                        name="cardholder_name"
                        className="form-control"
                        placeholder="John Snow"
                        aria-describedby="Your Name"
                        onChange={this.props.onChangeInfo}
                        value={this.props.cardholder_name}
                    />
                </div>
                {this.props.isEdit && (
                    <div className="d-flex justify-content-end">
                        <div className="d-flex gap-20 align-items-center">
                            <label className="d-flex gap-8 align-items-center cursor-pointer">
                                <input
                                    value={this.state.set_as_default_card}
                                    checked={this.state.set_as_default_card}
                                    onChange={this.handleDefaultChange}
                                    className="checkboxInput"
                                    disabled={this.state.loading}
                                    type="checkbox"
                                />
                                Set As Default
                            </label>
                            <button
                                className="button button-outline d-flex gap-10 align-items-center"
                                disabled={!this.state.card.complete || this.state.loading}
                            >
                                {this.state.loading && <Loading onlyPreloader />}
                                Add New Card
                            </button>
                        </div>
                    </div>
                )}
                {!this.props.isEdit && (
                    <>
                        <div className="custom-registration-user-information-text">
                            Your free trial is <strong>$0</strong>. After the trial, your card will
                            automatically be charged {' '}
                            <strong>
                                $
                                {formatNumber(
                                    Number(this.props.lastPrice || 0) -
                                        Number(this.props.totalSavings || 0) / 100,
                                )}{' '}
                                per period
                            </strong>{' '}
                             unless you cancel before the trial ends.
                        </div>
                        <div className="mb-3 registration-container-info-btns custom-registration-user-information-btns">
                            <button
                                type="button"
                                className="registration-container-info-previous"
                                onClick={() => this.props.previous()}
                            >
                                Back
                            </button>
                            <button
                                className="registration-container-info-submit"
                                disabled={!this.state.card.complete || this.state.loading}
                            >
                                {this.state.loading && <Loading onlyPreloader />}
                                {this.props.isFreeAiTemplate
                                    ? 'Start 30-Day FREE Trial'
                                    : 'Start 14-Day FREE Trial'}
                            </button>
                            <div></div>
                        </div>
                    </>
                )}
            </form>
        );
    }
}

export default Billing;
